import React from 'react';
import TabbedPage from '../../../Elements/TabbedPage';
import ClientPaymentsAdmin from './ClientPaymentsAdmin';
import ClientPrePaymentsAdmin from '../ClientPrePayment/ClientPrePaymentsAdmin';
import AppliedPaymentsReportAdmin from './AppliedPaymentsReportAdmin';

export default class ClientPaymentParentAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  tab = this.urlParams.has('tab') ? parseInt(this.urlParams.get('tab')) : 0;

  componentDidMount() {}

  tabs = [
    {
      label: 'All Payments',
      id: 'allpayments',
      icon: 'fa-solid fa-money-check',
      component: <ClientPaymentsAdmin type='all' />,
    },
    {
      label: 'Payments with Unapplied Balance',
      id: 'unappliedbalance',
      icon: 'fa-solid fa-money-check-dollar',
      component: <ClientPaymentsAdmin type='with unpaid' />,
    },
    {
      label: 'Prepayments',
      id: 'prepayments',
      icon: 'fa-solid fa-check',
      component: <ClientPrePaymentsAdmin />,
    },
    {
      label: 'Applied Payments Report',
      id: 'appliedpaymentsreport',
      icon: 'fa-solid fa-file-invoice-dollar',
      component: <AppliedPaymentsReportAdmin />,
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        <div className='bg-white p-1'>
          <div className='TabbedPage'>
            <TabbedPage
              tabs={this.tabs}
              openOnTab={this.tab}
              removeSearchParametersOnTabChange={true}
            />
          </div>
        </div>
      </div>
    );
  }
}
